module.exports = __webpack_public_path__ + "static/media/List_DOLL.8f7f0b03.mp3";